<script setup lang="ts">
import ClientError from '~/components/ClientError.vue';
import ErrorLoggedIn from '~/components/ErrorLoggedIn.vue';
import ServerError from '~/components/ServerError.vue';
usePageTitle().append('Ein Fehler ist aufgetreten');

const { isAuthenticated } = useUser();

const error = useError();
const isClientError = error.value?.statusCode && Math.floor(error.value.statusCode / 100) === 4;
</script>

<template>
    <ErrorLoggedIn v-if="isAuthenticated" />
    <ClientError v-else-if="isClientError" />
    <ServerError v-else />
</template>
